<template>
  <div
    class="released-jar-modal"
    @click="$parent.close()"
  >
    <p class="header">YOU'VE RELEASED A JAR OF FIREFLIES</p>
    <div class="display">
      <firefly-canvas
        class="fireflies"
        :width="300"
        :height="200"
        :count="30"
      ></firefly-canvas>
      <jar :color="color"></jar>
    </div>
    <p>Watch the tree in the clinic to see what happens</p>
  </div>
</template>

<script>
  import FireflyCanvas from "@/components/Fireflies/FireflyCanvas.vue";
  import Jar from "@/components/Fireflies/JarIconOpen.vue";
  export default {
    name: "ReleasedFireflyModal",
    props: ["color"],
    components: {
      FireflyCanvas,
      Jar
    }
  };
</script>

<style lang="scss">
  .released-jar-modal {
    width: 95%;
    margin: auto;
    border-radius: 8px;
    padding: 1em;
    background-color: rgb(60, 185, 163);

    p {
      text-align: center;
    }

    .display {
      width: 100%;
      height: 200px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      .fireflies {
        position: absolute;
      }
    }
  }
</style>
